export default __webpack_public_path__ + "static/media/bronze-frame.a2124e7f.png";